import { Injectable } from '@angular/core';
import { Headers, Request, Response, RequestMethod, RequestOptionsArgs, RequestOptions } from '@angular/http';
import { environment } from '../../../environments/environment';
import { HttpHelper } from '../../common/helpers/http.helper';
import { AddCustomerAgreement } from '../models/my-company/add-customer-agreement.model';
import { FAQMasterDc } from '../models/my-company/faq-master-dc.model';
import { ContractPagesData } from '../../customer/models/contract-pages.model';
import { Observable } from 'rxjs';
import { CustomerAgreementDc } from '../models/my-company/customer-agreement-dc.model';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { SessionHelper } from '../../common/helpers/session.helper';

@Injectable()
export class MyCompanyService {


    constructor(private _httpHelper: HttpHelper, private httpClient: HttpClient) {
    }

    public sendContract(sendObj) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headers });
        let url = "contact/contactfileinformation/updatesendcontractstatus";
        return this._httpHelper.put(environment.APIBaseUrl + url, sendObj, reqOption);
    }

    public saveRescindDay(rescindObj) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headers });
        let url = "contractdocument/updaterescind";
        return this._httpHelper.put(environment.APIBaseUrl + url, rescindObj, reqOption);
    }

    public saveCommunicationVideo(videoObj) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headers });
        let url = "contactMaster/communication/addupdatevideo";
        return this._httpHelper.post(environment.APIBaseUrl + url, videoObj, reqOption);
    }

    public getCustomerAgreementList(programId = 0) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = programId == 0 ? `contractdocument/getcontractpdflist` : `contractdocument/getcontractpdflistbyprogramid/${programId}`;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public getCustomerAgreementByProgramState(programId = 0, stateId = 0) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = `contractdocument/getcontractpdflistbyprogramidandstateid?programId=${programId}&stateId=${stateId}`;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public getCustomerAgreementByEmployeeId() {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = `contractdocument/getcontractpdflistbyemployeeid?employeeId=${SessionHelper.getUserId()}`;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public getCustomerAgreementById(id: any) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "customeragreement/details/" + id;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public addUpdateCustomerAgreement(addCustomerAgreement: AddCustomerAgreement) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headers });
        let url = "customeragreement/addupdate"
        return this._httpHelper.post(environment.APIBaseUrl + url, addCustomerAgreement, reqOption);
    }

    public deleteCustomerAgreementById(customerAgreementId: Number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Delete, headers: headers });
        let url = "contractdocument/deletecontractdocument/" + customerAgreementId
        return this._httpHelper.remove(environment.APIBaseUrl + url, reqOption);
    }

    public updateContractStatus(customerAgreementObj) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headers });
        let url = "contractdocument/activeinactivedocumentId";
        return this._httpHelper.put(environment.APIBaseUrl + url, customerAgreementObj, reqOption);
    }

    public updateDefaultCC(customerAgreementObj) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headers });
        let url = "contractdocument/updatedefaultccneeded";
        return this._httpHelper.put(environment.APIBaseUrl + url, customerAgreementObj, reqOption);
    }

    public previewContract(contract: CustomerAgreementDc) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "contractdocument/democontactcontract/" + contract.DocumentId;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    //// FAQ Master

    public getFAQMasterList() {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "faq/details"
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public getFAQMasterById(id: number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "faq/details/" + id;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public addUpdateFAQMaster(addFAQMaster: any) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "faq/addupdate"
        return this._httpHelper.post(environment.APIBaseUrl + url, addFAQMaster, reqOption);
    }

    public deleteFAQMasterById(faqMasterId: Number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Delete, headers: headers });
        let url = "faq/delete/" + faqMasterId;
        return this._httpHelper.remove(environment.APIBaseUrl + url, reqOption);
    }

    public UpdateFaqSequence(FaqId: Number, SequinceKey: String) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headers });
        let url = "faq/updatefaqsequence?FaqId=" + FaqId + "&SequinceKey=" + SequinceKey;
        return this._httpHelper.post(environment.APIBaseUrl + url, null, reqOption);
    }


    ///// Education ////


    public getEducationList() {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "education/details"
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public getEducationListofCustomer() {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "commeducation/details"
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public getEducationById(id: string) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "education/details/" + id;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public addUpdateEducation(addEducation: any) {
        // let headers: Headers = new Headers();
        // let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        // let url = "education/addupdate"
        // return this._httpHelper.post(environment.APIBaseUrl + url, addEducation, reqOption);
        let file: FormData = addEducation.FormData ? addEducation.FormData : new FormData();
        let headers: Headers = new Headers();
        addEducation.FormData = undefined;
        headers.append('RequestModel', JSON.stringify(addEducation));
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headers });
        let url = "education/addupdate";
        return this._httpHelper.postFile(environment.APIBaseUrl + url, file, reqOption);
    }

    public deleteEducationById(educationId: Number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Delete, headers: headers });
        let url = "education/delete/" + educationId;
        return this._httpHelper.remove(environment.APIBaseUrl + url, reqOption);
    }

    // Country List
    public getCountryList() {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "countryandstate/country/details"
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }
    // State List
    public getStateList(CountryId: Number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "countryandstate/state/stateList/" + CountryId;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    //////////////// SIDEKICKS ///////////////

    public getSidekicksList() {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "sidekicks/details"
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public getSidekicksById(id: string) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "sidekicks/details/" + id;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public addUpdateSidekicks(addSidekicks: any) {
        let file: FormData = addSidekicks.Image
        addSidekicks.Image = "";
        let headers: Headers = new Headers();
        headers.append('RequestModel', JSON.stringify(addSidekicks));
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headers });
        let url = "sidekicks/addupdate"
        return this._httpHelper.postFile(environment.APIBaseUrl + url, file, reqOption);

    }

    public deleteSidekicksById(sidekicksId: Number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Delete, headers: headers });
        let url = "sidekicks/delete/" + sidekicksId;
        return this._httpHelper.remove(environment.APIBaseUrl + url, reqOption);
    }

    // Suffix List
    public getSuffixMasterList() {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "contactMaster/suffix/detail";
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    // Langauge List
    public getLangaugeMasterList() {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "contactMaster/Language/detail";
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    ///////////////// //////////////// ///////////////////
    //                Note Type Master                  //
    ///////////////// //////////////// ///////////////////


    public getNoteTypeList() {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "contactcommunication/getnotetypemasterdetails"
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public getNoteTypeById(id: Number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "contactcommunication/notetypemaster/details/" + id;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public addUpdateNoteTypeMaster(addNoteTypeMaster: any) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "contactcommunication/notetypemaster/addupdate"
        return this._httpHelper.post(environment.APIBaseUrl + url, addNoteTypeMaster, reqOption);
    }

    public deleteNoteTypeById(noteMasterId: Number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Delete, headers: headers });
        let url = "contactcommunication/notetypemaster/delete/" + noteMasterId;
        return this._httpHelper.remove(environment.APIBaseUrl + url, reqOption);
    }


    public getProgramList() {
        const user = SessionHelper.getUser();
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        // let url = "affiliate/getaffiliatepagedropdownlists";
        let url = `program/getallprogrambyuser?userId=${user.UserId}&userType=${user.UserType}`;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public getAllProgramList() {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        // let url = "affiliate/getaffiliatepagedropdownlists";
        let url = `program/getallprogram`;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public addNewProgram(programMaster: any) {
        let file: any = [];
        if (typeof programMaster.FileData === 'object') {
            file = programMaster.FileData;
        }
        programMaster.FileData = "";
        let headers: Headers = new Headers();
        headers.append('RequestModel', JSON.stringify(programMaster));
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headers });
        let url = "program/addprogram"
        return this._httpHelper.postFile(environment.APIBaseUrl + url, file, reqOption);
    }

    public editProgram(programMaster: any) {
        let file: any = [];
        if (typeof programMaster.FileData === 'object') {
            file = programMaster.FileData;
        }
        programMaster.FileData = "";
        let headers: Headers = new Headers();
        headers.append('RequestModel', JSON.stringify(programMaster));
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headers });
        let url = "program/editprogram"
        return this._httpHelper.putFile(environment.APIBaseUrl + url, file, reqOption);
    }

    public getProgramDetail(programId: Number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "contactcommunication/notetypemaster/details/" + programId;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public deleteProgram(programId: Number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Delete, headers: headers });
        let url = `program/deleteprogram?ProgramId=${programId}`;
        return this._httpHelper.remove(environment.APIBaseUrl + url, reqOption);
    }

    public getVideoClassficationList() {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "videoclassification/getallvideoclassification";
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public getCampaignList(programId = 0) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        //let url = "emailtemplate/campaignmaster/getallcampaign";
        let url = programId == 0 ? "emailtemplate/campaignmaster/getallcampaign" : `emailtemplate/campaignmaster/getallcampaignbyprogramid/${programId}`;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public getCampaignById(campaignId: Number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "emailtemplate/getbycampaignid/" + campaignId;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public addNewCampaign(sendObj: any) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "emailtemplate/campaignmaster/addupdate";
        return this._httpHelper.post(environment.APIBaseUrl + url, sendObj, reqOption);
    }

    public getVideoByClassficationId(id: number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = `education/detailsbyclassificationid/${id}`;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public getContactEducationalVideoDetailsByContactId(contactid: Number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "customerportal/geteducationalvideolist/" + contactid;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    //add contract 
    public addContract(contractData, contractFile: any): Observable<ContractPagesData> {
        // let file: FormData = contractFile.HTMLFileName;
        // contractFile.HTMLFileName = "";
        let headers: Headers = new Headers();
        headers.append('RequestModel', JSON.stringify(contractData));
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headers });
        let url = "contractdocument/uploadpdfcontract"
        return this._httpHelper.postFile(environment.APIBaseUrl + url, contractFile, reqOption);
    }

    public saveContract(contractObj) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Put, headers: headers });
        let url = "contractdocument/updatecoordinates"
        return this._httpHelper.put(environment.APIBaseUrl + url, contractObj, reqOption);
    }

    public sendAffiliateContract(sendObj: any) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Put, headers: headers });
        let url = "affiliatescontract/updatesendcontractstatus";
        return this._httpHelper.put(environment.APIBaseUrl + url, sendObj, reqOption);
    }

    ///////////////// Email Template ////////////////////////

    public getEmailTemplates() {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "emailtemplate/details";
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public bindEmailTemplates() {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "emailtemplate/bindemailtemplate";
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public getEmailTemplateById(TemplateId: number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "emailtemplate/details/" + TemplateId;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public addUpdateEmailTemplate(sendObj: any) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "emailtemplate/addupdate/";
        return this._httpHelper.post(environment.APIBaseUrl + url, sendObj, reqOption);
    }

    public deleteEmailTemplateById(TemplateId: number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Delete, headers: headers });
        let url = "emailtemplate/delete/" + TemplateId;
        return this._httpHelper.remove(environment.APIBaseUrl + url, reqOption);
    }

    public getSMSList() {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "sms/details";
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public bindSMSMaster(programId = 0) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        programId = programId ? programId : 0;
        let url = `sms/bindsmsmaster?programId=${programId}`;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public getSMSById(SMSId: number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "sms/details/" + SMSId;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public addUpdateSMS(sendObj: any) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "sms/addupdate";
        return this._httpHelper.post(environment.APIBaseUrl + url, sendObj, reqOption);
    }

    public deleteSMSById(SMSId: number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Delete, headers: headers });
        let url = "sms/delete/" + SMSId;
        return this._httpHelper.remove(environment.APIBaseUrl + url, reqOption);
    }

    public sendSMS(smsData: any) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "sms/send";
        return this._httpHelper.post(environment.APIBaseUrl + url, smsData, reqOption);
    }

    public getSMSHistory(userId: Number, userType: string, pageNo: Number = 1, pageSize: Number = 1000) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "sms/getsenthistory?userId=" + userId + '&userType=' + userType + "&pageno=" + pageNo + "&pagesize=" + pageSize;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }


    public deleteSMS(smsId: Number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "sms/deletesmshistory/" + smsId;
        return this._httpHelper.remove(environment.APIBaseUrl + url, reqOption);
    }

    public getAllContactDropdownLists() {
        const user = SessionHelper.getUser();
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        // let url = "affiliate/getaffiliatepagedropdownlists";
        let url = `contact/getcontactpagedropdownlistsbyuser?userId=${user.UserId}&userType=${user.UserType}`;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public getBillingStatusList() {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "billingsummary/getbillingstatuslist/";
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public getContactsRoundMasterDetail() {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "contactMaster/roundmaster/details"
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public getProgressList() {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "progress/getallprogress";
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public getallRelationships() {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "relationshipmaster/getallrelationships";
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public getIndustryListDetails() {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "affiliate/industry/details"
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public getTemperatureList() {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "affiliate/temperature/details"
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public getContactTypeList() {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "contactMaster/contacttype/details"
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public getAffiliateTypeList() {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "affiliate/typemaster/details"
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public getLetterTemplateFieldList() {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "strategy/LetterTemplateFieldMasterManager/getlist";
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public getEmailQueueDetails(affiliateId: Number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = "emailqueue/contact/details/" + affiliateId;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public saveEmailQueueDetails(data: any) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headers });
        let url = "emailqueue/addupdate"
        return this._httpHelper.post(environment.APIBaseUrl + url, data, reqOption);
    }

    public deleteEmailQueue(data: any) {

        let url = "emailqueue/delete";
        const options =
        {
            headers: new HttpHeaders(),
            body: data,
        };

        return this.httpClient.delete(environment.APIBaseUrl + url, options)
    }

    public pauseUnpauseCampaign(campaignObj) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headers });
        let url = "emailtemplate/campaignmaster/pauseunpausecampaign";
        return this._httpHelper.put(environment.APIBaseUrl + url, campaignObj, reqOption);
    }

    public deleteCampaignDetails(campaignId: Number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Delete, headers: headers });
        let url = "emailtemplate/campaignmaster/delete/" + campaignId
        return this._httpHelper.remove(environment.APIBaseUrl + url, reqOption);
    }

    public pauseContactEducationalVideo(data) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headers });
        let url = "sidekicks/pauseorunpausecontacteduvideos"
        return this._httpHelper.put(environment.APIBaseUrl + url, data, reqOption);
    }

    public getVideoClassifications() {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headers });
        let url = "videoclassification/getallvideoclassification"
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public getLetterInPortalList() {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headers });
        let url = `program/getletterinportalbyuserid/${SessionHelper.getUserId()}`;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public getEmployeePackageList() {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headers });
        let url = `billing/billingpackage/getpackagesbyuserid/${SessionHelper.getUserId()}`;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public getEmployeeVideoClassificationList() {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headers });
        let url = `videoclassification/getallvideoclassificationbyuserid/${SessionHelper.getUserId()}`;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public getEmployeeCreditMonitoringList() {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headers });
        let url = `processing/creditmonitoring/getbyuserId/${SessionHelper.getUserId()}`;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public updateContractPrograms(customerAgreementObj) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headers });
        let url = "contractdocument/updateprogramids";
        return this._httpHelper.put(environment.APIBaseUrl + url, customerAgreementObj, reqOption);
    }

    public getStatusByProgramId(programId) {
        let headers: Headers = new Headers();
        programId = programId ? programId : 0;
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headers });
        let url = `contactMaster/contactstatus/getbyprogramid/${programId}`;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public getRoundListByProgramId(programId) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headers });
        let url = `contactMaster/roundmaster/getbyprogramid/${programId}`;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public getBillingSttausListByProgramId(programId) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headers });
        let url = `contactMaster/billingstatus/getbyprogramid/${programId}`;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public getEmployeeByFileAssignmentIds(fileAssignmentIds: Array<number> = [], employeeId: Number = 0) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        // employeeId = employeeId != 0 ? employeeId : SessionHelper.getUserId();
        let url = `employee/byfileassignment?fileAssignmentIds=${fileAssignmentIds.toString()}&employeeId=${SessionHelper.getUserId()}`;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public updateDocumentVideoMessage(data: any) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = `contractdocument/updatevideomessage`;
        return this._httpHelper.put(environment.APIBaseUrl + url, data, reqOption);
    }

    public getContractAction(documentId: string) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = `contractdocument/action/get/${documentId}`;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public addUpdateContractAction(data: any) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = `contractdocument/action/addupdate`;
        return this._httpHelper.post(environment.APIBaseUrl + url, data, reqOption);
    }


    public getTeamListByEmployeeId() {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = `affiliate/getteamlistbyemployeeid?employeeId=${SessionHelper.getUserId()}`;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public getProgramWelcomeLetters(programId: number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = `program/round/welcomeletter/get/${programId}`;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public addUpdateProgramWelcomeLetter(data: any) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = `program/round/welcomeletter/addupdate`;
        return this._httpHelper.post(environment.APIBaseUrl + url, data, reqOption);
    }

    public deleteProgramLetter(id: number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = `program/round/welcomeletter/delete/${id}`;
        return this._httpHelper.remove(environment.APIBaseUrl + url, reqOption);
    }

    public getProgramVideoList(programId: number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = `program/video/getallprogramvideos/${programId}`;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public addUpdateProgramVideo(programVideo: any) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = `program/video/addupdate`;
        return this._httpHelper.post(environment.APIBaseUrl + url, programVideo, reqOption);
    }

    public addUpdateContractStates(programVideo: any) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = `contractdocument/updatestateids`;
        return this._httpHelper.put(environment.APIBaseUrl + url, programVideo, reqOption);
    }

    public getDomainList() {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = `domainmaster/details`;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public addUpdateDomain(domainData: any) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = `domainmaster/addupdate`;
        return this._httpHelper.post(environment.APIBaseUrl + url, domainData, reqOption);
    }

    public getFormList() {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = `formmaster/details`;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public addUpdateForm(formData: any) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = `formMaster/addupdate`;
        return this._httpHelper.post(environment.APIBaseUrl + url, formData, reqOption);
    }

    public deleteForm(formId: string) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = `formmaster/delete/${formId}`;
        return this._httpHelper.remove(environment.APIBaseUrl + url, reqOption);
    }

    public getFormDetails(formUrl: string) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = `formmaster/details/bydomainurl?domainUrl=${formUrl}`;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public addUpdateSignStatement(data: any, documentId: number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = `signstatement/${documentId}/addupdate`;
        return this._httpHelper.post(environment.APIBaseUrl + url, data, reqOption);
    }

    public getSignStatementList(documentId: number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = `signstatement/${documentId}`;
        return this._httpHelper.get(environment.APIBaseUrl + url, reqOption);
    }

    public deleteSignStatement(statementId: number) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = `signstatement/${statementId}`;
        return this._httpHelper.remove(environment.APIBaseUrl + url, reqOption);
    }

    public updateContractMessage(data) {
        let headers: Headers = new Headers();
        let reqOption: RequestOptions = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let url = `contractdocument/upcontractmessage`;
        return this._httpHelper.put(environment.APIBaseUrl + url, data, reqOption);
    }
}




// WEBPACK FOOTER //
// /Users/hrushabhmakwana/Documents/CAM/CreditRepairMenAngular/src/app/crm/services/my-company.service.ts